import { Box, Divider, useTheme } from "@mui/material";
import DiffPercentageTag from "./DiffPercentageTag";

type SectionDividerProps = {
    readonly showDivider: boolean;
    readonly percentageDifference?: number;
    readonly showPercentage?: boolean;
    readonly position: "left" | "right";
    readonly forceSideBySide?: boolean;
};

export function SectionDivider(props: Readonly<SectionDividerProps>) {
    const { showDivider, percentageDifference, showPercentage, position, forceSideBySide = false } = props;
    const theme = useTheme();

    if (!showDivider) return null;

    return (
        <>
            {showPercentage && percentageDifference !== undefined && (
                <Box
                    position="absolute"
                    sx={{
                        top: "50%",
                        [position === "left" ? "left" : "right"]: "0%",
                        transform: `translate(${position === "left" ? "-50%" : "50%"}, -50%)`,
                        zIndex: 2,
                        display: forceSideBySide ? "block" : { xs: "none", lg: "block" },
                    }}
                >
                    <DiffPercentageTag value={percentageDifference} />
                </Box>
            )}
            <Divider
                orientation="vertical"
                flexItem
                sx={{
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    [position === "left" ? "left" : "right"]: "0%",
                    zIndex: 1,
                    display: forceSideBySide ? "block" : { xs: "none", lg: "block" },
                }}
            />
            <Divider
                sx={{
                    display: forceSideBySide ? "none" : { xs: "block", lg: "none" },
                    my: theme.spacing(4),
                }}
            />
            {showPercentage && percentageDifference !== undefined && (
                <Box
                    sx={{
                        position: "absolute",
                        bottom: theme.spacing(2.5),
                        left: "50%",
                        transform: "translateX(-50%)",
                        zIndex: 2,
                        display: forceSideBySide ? "none" : { xs: "block", lg: "none" },
                    }}
                >
                    <DiffPercentageTag value={percentageDifference} position="bottom" />
                </Box>
            )}
        </>
    );
}

export default SectionDivider;
